import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  form: {
    width: "100%", // Fix IE 11 issue.
    padding: "15px 20px",
    "& div:nth-child(1)": {
      marginBlockEnd: "1.6875rem",
    },
    "& label": {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 700,
      color: "#0F172A",
    },
    "& .MuiOutlinedInput-input": {
      padding: "8px 12px",
      height: 24,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#E8EAEF",
    },
    "& .MuiOutlinedInput-root": {
      color: "#A2A9BD",
    },
  },
  subtitle: {
    fontSize: theme.typography.pxToRem(22),
    marginInlineEnd: 27,
    marginInlineStart: 14,
  },
  top: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(2),
  },
  bottom: {
    width: "100%", // Fix IE 11 issue.
    marginBottom: 10,
  },
  submit: {
    margin: theme.spacing(2, 0, 1),
  },
  group: {
    display: "flex",
    marginBlockStart: "1.625rem",
    columnGap: "1.563rem",
    "& .MuiFormGroup-root": {
      flexBasis: "30%",
    },
  },
  formGroup: {
    marginBlockEnd: "1.5rem",
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: "#CF1B1B",
    },
    "& .MuiFormLabel-root.Mui-error": {
      color: "#CF1B1B",
    },
    "& .MuiFormLabel-root": {
      marginBlockEnd: "10px",
    },
  },
  iconError: {
    "& path": {
      fill: "#CF1B1B",
    },
  },
  errorText: {
    fontSize: theme.typography.pxToRem(14),
    fontFamily: "Lato",
    fontWeight: 400,
    color: "#CF1B1B",
  },
  errorStripe: {
    color: "#CF1B1B",
  },
}));
